import React from 'react';
import styled from 'styled-components';

// Shared components
import Container from '~/App/shared/components/Container';
import { GenericCertificate } from '~/App/shared/components/Donation';

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.lightPolar};
`;

class GenericCertificateForm extends React.Component {
  render() {
    const { data, component } = this.props;

    return (
      <Wrapper>
        <Container
          width="limited"
          paddingLeft="small"
          paddingRight="small"
          paddingTop="small"
          paddingBottom="small"
        >
          <GenericCertificate data={data} component={component} />
        </Container>
      </Wrapper>
    );
  }
}

export default GenericCertificateForm;
